import listToString from 'services/listToString';

// What the selection's line is called: the entities selected (the last
// drill-down, or the entity page's entity), as "John Smith" or
// "John Smith (+2)". 'Selected' when the selection isn't a list of names,
// e.g. an exclusion.
const getSelectedSeriesName = (selected: FilterInput | undefined): string => {
  const keyword = (selected?.keywords ?? []).find(
    (k) => !k.exclude && k.values.length > 0,
  );
  return keyword ? listToString(keyword.values, 1) : 'Selected';
};

export default getSelectedSeriesName;
